import { Button } from '@material-tailwind/react'
import React from 'react'

export default function ButtonComp(props) {
const {value,handleValue}=props
return (
<Button  onClick={()=>{handleValue(value)}} color='yellow' >{value?value:"All Product"}</Button>
  )
}
